import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useArenaLeaderboard } from '@/api/arenaHooks'

export default function ArenaLeaderboardPage() {
  const { t } = useTranslation('pages')
  const { agentType } = useParams<{ agentType: string }>()
  const query = useArenaLeaderboard(agentType)
  const ratings = query.data?.ratings ?? []

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <div className="mb-5 flex items-center gap-3">
        <Link to="/arena" className="text-sm text-foreground/60 hover:text-foreground">
          {t('arena.backToArena')}
        </Link>
        <h1 className="text-xl font-semibold text-foreground">{t('arena.leaderboardTitle', { agentType })}</h1>
      </div>

      {query.isLoading ? (
        <div className="text-sm text-foreground/60">{t('arena.loading')}</div>
      ) : ratings.length === 0 ? (
        <div className="text-sm text-foreground/50">{t('arena.noVotes')}</div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border-subtle text-left text-xs font-medium text-foreground/50">
              <th className="py-2">{t('arena.rank')}</th>
              <th>{t('arena.model')}</th>
              <th className="text-right">{t('arena.winRate')}</th>
              <th className="text-right">{t('arena.wins')}</th>
              <th className="text-right">{t('arena.losses')}</th>
              <th className="text-right">{t('arena.ties')}</th>
              <th className="text-right">{t('arena.comparisons')}</th>
            </tr>
          </thead>
          <tbody>
            {ratings.map((r, i) => (
              <tr key={r.model} className="border-b border-border-subtle/50">
                <td className="py-2 text-foreground/50">{i + 1}</td>
                <td className="font-medium text-foreground">{r.model}</td>
                <td className="text-right text-foreground">
                  {r.win_rate == null ? '–' : `${Math.round(r.win_rate * 100)}%`}
                </td>
                <td className="text-right text-emerald-400">{r.wins}</td>
                <td className="text-right text-red-400">{r.losses}</td>
                <td className="text-right text-foreground/60">{r.ties}</td>
                <td className="text-right text-foreground/60">{r.n_comparisons}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
